/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_StartingInputs */



/**
* | output |
* | --- |
* | "Starting publish workflow" |
*
* @param {Iconik_Publish_Status_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_starting = /** @type {((inputs?: Iconik_Publish_Status_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demarrage du flux de publication")
	if (locale === "de") return /** @type {LocalizedString} */ ("Starten des Veröffentlichungs-Workflows")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio del flusso di lavoro di pubblicazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Запуск процесса публикации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando el flujo de trabajo de publicación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启动发布工作流程")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開ワークフローの開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन कार्यप्रवाह प्रारंभ करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando o fluxo de trabalho de publicação")
	return /** @type {LocalizedString} */ ("Starting publish workflow")
});